export default "/images/black-days-image.png?110c22dc1be741b6b8492a20cf9d9ed9";